import React from 'react';
import styled from 'styled-components';

export default function About() {
  return (
    <AboutContainer>
      <div className='about'>
        <h2>Mulla</h2>
        <div>
          <p className='about-info'>
            Uitleg van waar de naam Mulla komt en waar het voor staat
          </p>
        </div>
      </div>
    </AboutContainer>
  );
}

const AboutContainer = styled.div`
  text-align: center;
  background: var(--primaryLessonsColor);

  h2 {
    color: var(--primaryBtnColor);
  }

  .about-info {
    justify-content: center;
  }

  .about {
    justify-content: space-between;
  }
`;
